//import moment from "moment";

export const monthTitle = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
export const defaultCostListTableSorted = [{ dataField: "MonthNumber", order: "desc" }];
export const defaultCostsNotAccountedSorted = [{ dataField: "districtname", order: "asc" }];
